import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { useAppSelector } from '@/shared/hooks';
import { Icon } from '@/shared/ui';

import { billingModel } from '@/entities/billing';
import { composedModel } from '@/entities/composed';
import { organizationModel } from '@/entities/organization';

import styles from './DiagnocoinBalanceRow.module.scss';

type DiagnocoinBalanceRowProps = {
  className?: string;
  testID?: string;
};

export const DiagnocoinBalanceRow: FC<DiagnocoinBalanceRowProps> = (props) => {
  const { className, testID } = props;

  const { formatMessage, formatDate } = useIntl();

  const available = useAppSelector(
    billingModel.selectors.selectDiagnocoinAvailable,
  );
  const expiringSoon = useAppSelector(
    billingModel.selectors.selectExpiringSoonDiagnocoins,
  );
  const isDiagnocoinsEnabled = useAppSelector(
    composedModel.selectors.selectIsDiagnocoinsEnabled,
  );
  const currentOrganization = useAppSelector(
    organizationModel.selectors.selectCurrentOrganization,
  );

  if (
    !isDiagnocoinsEnabled ||
    available === 0 ||
    !currentOrganization?.YourPermissions?.BillingCanViewInventory
  ) {
    return null;
  }

  return (
    <div
      data-testid={testID}
      className={cn(styles.container, className)}
      data-component="diagnocoin-balance-row"
    >
      <span className={styles.glyph}>
        <Icon name="cat" size={18} />
      </span>

      <div className={styles.text}>
        <span className={cn('p2', 'bold')}>
          {formatMessage(
            {
              id: 'diagnocoins.balance',
              defaultMessage:
                '{available, plural, one {# coin} other {# coins}}',
            },
            { available },
          )}
        </span>

        {expiringSoon !== null && (
          <span className={cn(styles.expiry, 'p3')}>
            {formatMessage(
              {
                id: 'diagnocoins.expiringSoon',
                defaultMessage:
                  '{coins, plural, one {# coin expires} other {# coins expire}} {date}',
              },
              {
                coins: expiringSoon.coins,
                date: formatDate(expiringSoon.expiresAt, {
                  dateStyle: 'medium',
                }),
              },
            )}
          </span>
        )}
      </div>
    </div>
  );
};
